import React from 'react';
import { useState } from 'react'
// import products from '../data/computer'
// import './BarCharts.css'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import 'bootstrap/dist/css/bootstrap.css';
import FormsRenew from './Forms/FormsRenew'
import FormsAddLicense from './Forms/FormsAddLicense'
import './FormsSelector.css'

export default function FormsSelector() {
    
    const [valor, setValue] = useState('1')

    const handleSelect = (e) => {
        setValue(e)
    }
    function pageControl() {
        if (valor === '1') {
            return (
                <div>
                    {<FormsRenew></FormsRenew>}
                </div>
            );
        } else if (valor === '2') {
            return (
                <div>
                    <FormsAddLicense></FormsAddLicense>
                </div>
            );
        }
    }
    return (
        <div >
            <DropdownButton id="dropdown-forms-selector" title="Selecione o formulário"
                onSelect={handleSelect} >
                <Dropdown.Item eventKey='1' as="button">Renovar licença</Dropdown.Item>
                <Dropdown.Item eventKey='2' as="button">Gerar licença</Dropdown.Item>
            </DropdownButton>
            {pageControl()}
        </div>
    );
}



